
<script>
import JmFilterEntity from './Entity'

export default {
	name: "JmFilterOrganisation",

	extends: JmFilterEntity
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/FilterWidgets/Organisation.vue